import { Alert } from '@vtex/shoreline'
import i from 'i18next'

import { Button } from '~/components/Buttons'
import Loading from '~/components/Loading'
import Form from '~/components/unform/Form'

import { useRequestAds } from '../hooks/useRequestAds'
import AdTypeSection from './AdTypeSection'
import AuxiliarySection from './AuxiliarySection'
import ContextSection from './ContextSection'
import ContextSettings from './ContextSettings'
import { DebugMode } from './DebugMode'

const FormRequestAds = () => {
  const {
    formRef,
    initialData,
    handleChange,
    handleSubmit,
    loadingAds,
    errosAds,
    showContextSection
  } = useRequestAds()

  return (
    <div className="col-6">
      <Form
        ref={formRef}
        onSubmit={handleSubmit}
        initialData={initialData}
        onChange={handleChange}
      >
        <AdTypeSection />

        <ContextSection />

        {showContextSection && <ContextSettings />}

        <AuxiliarySection />

        {/* If super admin - section debug mode */}
        <DebugMode />

        <Loading status={loadingAds}>Loading ads...</Loading>

        {errosAds && (
          <Alert variant="critical">
            {i.t('c:messages.errorOccurred.message')}
          </Alert>
        )}

        <footer>
          <Button type="submit" text={i.t('common:actions.confirm')} />
        </footer>
      </Form>
    </div>
  )
}

export default FormRequestAds
